export default "__VITE_ASSET__HnAUCak3__"